import { motion } from "framer-motion";

// Fade-up reveal on scroll. Wrap any block.
export const Reveal = ({ children, delay = 0, className = "", y = 28, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-60px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);

export default Reveal;
